import { drag } from 'd3-drag';
import { select } from 'd3-selection';

export const d3 = {
  select,
  drag,
};
